module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-10.d2761395.svg";